import { Text } from '../helpers/elements';

class Win extends Phaser.State {

  // winner é { skin, name } vindo do servidor, ou nada quando o oponente saiu.
  init(winner) {
    this.winner = winner
  }

  create() {
    new Text({
      game: this.game,
      x: this.game.world.centerX,
      y: this.game.world.centerY,
      text: this.winnerText(),
      style: {
        font: '30px Areal',
        fill: '#FFFFFF'
      }
    })
  }

  update() {
    if( this.game.input.keyboard.isDown(Phaser.Keyboard.ENTER) ) {
      this.returnToMenu();
    }
  }

  returnToMenu() {
    this.state.start('Menu');
  }

  winnerText() {
    if (this.winner) {
      let who = this.winner.name || this.winner.skin
      return `Player: "${who}" won! Press Enter to return to main menu.`
    }

    return 'Opponent left! Press Enter to return to main menu.'
  }
}

export default Win;
